var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeAvatar9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0456,
    cy: 35.0454,
    r: 33.3766,
    fill: "#DFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1329 13.5144C40.7279 13.5144 47.7247 9.26557 50.521 16.3453C51.8792 19.7821 50.2958 26.8866 47.3349 33.2884C47.5794 35.4264 47.7223 37.8525 47.7223 40.4202C47.7223 49.0246 46.1583 56 44.2239 56C39.1082 56 43.8728 37.5893 35.1304 37.5893C26.3881 37.5893 31.0365 56 26.037 56C24.105 56 22.541 49.0246 22.541 40.4202C22.541 37.8525 22.6815 35.4264 22.9284 33.2884C19.9699 26.8866 18.3841 19.7821 19.7399 16.3453C22.5386 9.26557 29.533 13.5144 35.128 13.5144H35.1329Z",
    fill: "#307F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0235 22.0701H40.2382V19.6432C40.2382 18.9196 39.6529 18.3333 38.9293 18.3333H31.0718C30.3483 18.3333 29.7629 18.9196 29.7629 19.6432V22.0701H17.9766C17.2531 22.0701 16.6667 22.8474 16.6667 23.5709C16.6667 24.2945 17.2531 25.0728 17.9766 25.0728H29.7619V27.4997C29.7619 28.2232 30.3473 28.8086 31.0709 28.8086H38.9283C39.6519 28.8086 40.2373 28.2232 40.2373 27.4997V25.0728H52.0226C52.7461 25.0728 53.3325 24.2945 53.3325 23.5709C53.3325 22.8474 52.7461 22.0701 52.0226 22.0701H52.0235ZM37.3996 25.9556H32.6159V21.1719H37.3996V25.9556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar9);
export default __webpack_public_path__ + "static/media/Office-Avatar-9.0bac6aeca4255a5695321aea83fe3d5f.svg";
export { ForwardRef as ReactComponent };